<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2">People</h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'people' }">People</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

            <form @submit.prevent="addNew" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">        


                <!-- ******* Card ******** -->
                <div class="col-md-12 mb-5">

                    <!-- Card Background -->
                        <!-- <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground">Background
                                            <span id="iconToggleBackground" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                       
                                       
                                       <div class="form-group">
                                            <label>Background 1200 * 440
                                                <button v-if="row.background_preview" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.background_preview = ''; row.background = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.background_preview" 
                                                :src="row.background_preview" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onBackgroundChange">
                                        </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- End Card Background -->

                    <!-- Card Accreditations -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabMask" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Mask')"
                                        aria-expanded="false" 
                                        aria-controls="collapseMask" 
                                        data-toggle="collapse"
                                        data-target="#collapseMask">Mask
                                        <span id="iconToggleMask" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMask" 
                                    class="collapse" 
                                    aria-labelledby="TabMask" 
                                    data-parent="#accordion">

                                <div class="col-12 row pt-3">
                            
                            <div class="col-10 tab-danger">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a href="#tab-english" 
                                                    class="nav-link active show" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="true">English
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a href="#tab-arabic" 
                                                    class="nav-link" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="false">Arabic
                                                </a>
                                            </li>
                                        </ul>
                                        
                                        <div class="tab-content">
                                            <div role="tabpanel" 
                                                class="tab-pane fade active show" 
                                                id="tab-english">

                                                <div class="col-12 row mt-5">

                                                    <div class="form-group col-12">
                                        <label for="input1">Background Title</label>
                                        <editor
                                            id="editor01"
                                            v-model="row.bgTitle"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 200,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>

                                                </div>
                                            </div>

                                            <div role="tabpanel" 
                                                class="tab-pane fade in" 
                                                id="tab-arabic">

                                                <div class="col-12 row mt-5">

                                                    <div class="form-group col-12">
                                        <label for="input1">Background Title</label>
                                        <editor
                                            id="editor01_ar"
                                            v-model="row.bgTitle_ar"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 200,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- End Title -->

                                    <!-- Slug -->
                                    <div class="form-group col-2 py-3 mt-10">
                                        <label for="input2">Background Color</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="color" 
                                                style="height: 200px" 
                                                v-model="row.bgColor">
                                    </div>
                                    <!-- End Slug -->

                                    
                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Writer -->

                    <!-- Card Accreditations -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabContent" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Content')"
                                        aria-expanded="false" 
                                        aria-controls="collapseContent" 
                                        data-toggle="collapse"
                                        data-target="#collapseContent">Content
                                        <span id="iconToggleContent" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseContent" 
                                    class="collapse" 
                                    aria-labelledby="TabContent" 
                                    data-parent="#accordion">

                                <div class="col-12 pt-3 row">
                                    
                                    <div class="form-group col-3">
                                        <label for="input1">Locations</label>
                                        <span v-if="locationLoading">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                            </span>
                                        </span>
                                        <select v-if="!locationLoading"
                                                class="form-control" 
                                                v-model="row.location_id"
                                                @change="fetchOffices()">
                                            <option value="">Select Location</option>
                                            <option v-for="(row, idx) in locations"
                                                    :key="idx"
                                                    :value="row.id">
                                                    {{ row.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="form-group col-3">
                                        <label for="input1">Offices</label>
                                        <span v-if="officeLoading">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                            </span>
                                        </span>
                                        <select v-if="!officeLoading"
                                                class="form-control" 
                                                v-model="row.office_id">
                                            <option value="">Select Office</option>
                                            <option v-for="(row, idx) in offices"
                                                    :key="idx"
                                                    :value="row.id">
                                                    {{ row.name }}
                                            </option>
                                        </select>
                                    </div>



                                    <div class="form-group col-3">
                                        <label for="input1">Sectors</label>
                                        <span v-if="sectorLoading">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                            </span>
                                        </span>
                                        <select v-if="!sectorLoading"
                                                class="form-control" 
                                                v-model="row.sector_id"
                                                @change="fetchSubSectors()">
                                            <option value="">Select Sector</option>
                                            <option v-for="(row, idx) in sectors"
                                                    :key="idx"
                                                    :value="row.id">
                                                    {{ row.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="form-group col-3">
                                        <label for="input1">Sub Sectors</label>
                                        <span v-if="subsectorLoading">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                            </span>
                                        </span>
                                        <select v-if="!subsectorLoading"
                                                class="form-control" 
                                                v-model="row.subsector_id">
                                            <option value="">Select Sub Sector</option>
                                            <option v-for="(row, idx) in subsectors"
                                                    :key="idx"
                                                    :value="row.id">
                                                    {{ row.name }}
                                            </option>
                                        </select>
                                    </div>


                                    <div class="form-group col-3">
                                        <label for="input1">Services</label>
                                        <span v-if="serviceLoading">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                            </span>
                                        </span>
                                        <select v-if="!serviceLoading"
                                                class="form-control" 
                                                v-model="row.service_id"
                                                @change="fetchSubServices()">
                                            <option value="">Select Service</option>
                                            <option v-for="(row, idx) in services"
                                                    :key="idx"
                                                    :value="row.id">
                                                    {{ row.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="form-group col-3">
                                        <label for="input1">Sub Services</label>
                                        <span v-if="subserviceLoading">
                                            <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                            </span>
                                        </span>
                                        <select v-if="!subserviceLoading"
                                                class="form-control" 
                                                v-model="row.subservice_id">
                                            <option value="">Select Sub Service</option>
                                            <option v-for="(row, idx) in subservices"
                                                    :key="idx"
                                                    :value="row.id">
                                                    {{ row.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-6"></div>
                                    <div class="col-12"><p></p><br/></div>
                                    


                                    <div class="form-group col-6">
                                            <label>Background 200 * 270
                                                <button v-if="row.preview" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview = ''; row.image = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview" 
                                                :src="row.preview" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImageChange">
                                    </div>

                                    <div class="form-group col-6">
                                        <label for="input1">Background Color</label>
                                        <input class="form-control" 
                                                type="color" 
                                                v-model="row.bgColor"
                                                style="height: 100px">
                                    </div>

                                    <!-- Title -->
                                    <div class="form-group col-6">
                                        <label for="input1">Name (en)</label>
                                        <input class="form-control" 
                                                id="input1" 
                                                type="text" 
                                                v-model="row.name">
                                    </div>
                                    <div class="form-group col-6">
                                        <label for="input1">Name (ar)</label>
                                        <input class="form-control" 
                                                id="input1" 
                                                type="text" 
                                                v-model="row.name_ar">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Slug -->
                                    <div class="form-group col-6">
                                        <label for="input2">Slug</label>
                                        <input class="form-control text-lowercase"
                                                id="input2"  
                                                type="text" 
                                                v-model="row.slug" 
                                                @keydown.space.prevent 
                                                @paste="onSlugPaste"
                                                @change="onSlugChange(false)">
                                    </div>
                                    <div class="form-group col-6"></div>
                                    <!-- End Slug -->


                                    <div class="form-group col-6">
                                        <label for="input2">Position (en)</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="text" 
                                                v-model="row.position">
                                    </div>

                                    <div class="form-group col-6">
                                        <label for="input2">Position (ar)</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="text" 
                                                v-model="row.position_ar">
                                    </div>
                                    

                                    <div class="form-group col-6">
                                        <label for="input2">Email</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="email" 
                                                v-model="row.email">
                                    </div>
                                    <div class="form-group col-6"></div>

                                    <div class="form-group col-6">
                                        <label for="input2">Phone D</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="text" 
                                                v-model="row.phone_d">
                                    </div>
                                    <div class="form-group col-6"></div>

                                    <div class="form-group col-6">
                                        <label for="input2">Phone F</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="text" 
                                                v-model="row.phone_f">
                                    </div>
                                    <div class="form-group col-6"></div>

                                    <!-- Sort -->
                                    <div class="form-group col-6">
                                        <label for="input3">Sort</label>
                                        <input class="form-control" 
                                                id="input3" 
                                                min="0"
                                                type="number" 
                                                v-model.number="row.sort">
                                    </div>
                                    <!-- End Sort -->


                                    <div class="col-12"></div>
                                <h4><br/>Status & Visibility</h4>
                                    <div class="col-md-12">
                                    <!-- Status -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch1" 
                                                    :checked="row.status"
                                                    @click="onStatus">
                                                <label class="custom-control-label" 
                                                    for="customSwitch1"
                                                    v-html="(row.status) ? 'Inactive' : 'Active'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Status -->

                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch3" 
                                                    :checked="row.has_faq"
                                                    @click="onFaq">
                                                <label class="custom-control-label" 
                                                    for="customSwitch3"
                                                    v-html="(row.has_faq) ? 'Hide FAQ' : 'Show FAQ'">
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 row" v-if="row.has_faq">
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>FAQ Link</label>
                                                <input type="text" 
                                                    class="form-control" 
                                                    v-model="row.faq_link">
                                            </div>
                                        </div>


                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch4" 
                                                    :checked="row.has_download"
                                                    @click="onDownload">
                                                <label class="custom-control-label" 
                                                    for="customSwitch4"
                                                    v-html="(row.has_download) 
                                                    ? 'Hide Download File' : 'Show Download File'">
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 row" v-if="row.has_download">
                                            <div class="form-group col-3">
                                                <label>Download Title (en)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.download_name">
                                            </div>
                                            <div class="form-group col-3">
                                                <label>Download Title (ar)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.download_name_ar">
                                            </div>
                                            <div class="form-group col-6">
                                                <label>Download File
                                                    <button v-if="row.download_preview" 
                                                        type="button" 
                                                        class="btn btn-danger btn-sm btn-pill"
                                                        style='margin-top: -10px; margin-left: 10px'
                                                        @click="row.download_preview = ''; 
                                                                row.download_file = ''">
                                                        Remove File
                                                    </button>
                                                </label>
                                                <a v-if="row.download_preview" 
                                                        :href="row.download_preview" 
                                                        target="_blank" class="pull-right">Preview
                                                    </a>
                                                <input type="file" class="form-control" 
                                                @change="onFileChange">
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>Download Image 180 * 220
                                                    <button v-if="row.download_image_preview" 
                                                        type="button" 
                                                        class="btn btn-danger btn-sm btn-pill"
                                                        style='margin-top: -10px; margin-left: 10px'
                                                        @click="row.download_image_preview = ''; 
                                                                row.download_image = ''">
                                                        Remove Image
                                                    </button>
                                                </label>
                                                <p>
                                                    <img v-if="row.download_image_preview" 
                                                        :src="row.download_image_preview"
                                                        style="max-width: 50%">
                                                </p>
                                                <input type="file" class="form-control" 
                                                @change="onFilePreviewChange" accept="image/*">
                                            </div>
                                        </div>





                                    </div>
                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Writer -->

                </div>
                <!-- ******* End Card ******** -->


                </div>
            </div>
            <!-- End Content -->


                <!-- Buttons -->
                <div class="col-md-12 row">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" :disabled="btnLoading">
                            <span v-if="btnLoading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading" class="ti-check-box"></span>
                            <span v-if="!btnLoading"> Create People</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" class="btn btn-danger" 
                            :disabled="btnLoading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>
                <!-- End Buttons -->


                </form>
            </div>

                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            Editor
        },
        data(){
            return {
                auth: {
                    access_token: '',
                },
                row: {
                    status: 1,
                    sort: 0,
                    has_faq: 0,
                    faq_link: '',
                    has_download: 0,
                    download_name: '',
                    download_name_ar: '',
                    download_image_preview: '',
                    download_image: '',
                    download_preview: '',
                    download_file: '',
                    
                    background_preview: '',
                    background: '',
                    preview: '',
                    image: '',
                    bgTitle: '',
                    bgTitle_ar: '',
                    bgMaskColor: '#000000',

                    location_id: '',
                    office_id: '',
                    sector_id: '',
                    subsector_id: '',
                    service_id: '',
                    subservice_id: '',

                    bgColor: '#000000',
                    name: '',
                    name_ar: '',
                    slug: '',
                    position: '',
                    position_ar: '',
                    email: '',
                    phone_d: '',
                    phone_f: '',
                },
                editor: {
                    api_key: 'xahz1dg338xnac8il0tkxph26xcaxqaewi3bd9cw9t4e6j7b',
                    menubar: 'file edit view insert format tools table tc help',
                    plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount'
                            ],
                    toolbar: 'undo redo | formatselect | bold italic backcolor | \
                              alignleft aligncenter alignright alignjustify | \
                              bullist numlist outdent indent | removeformat | help',
                },

                locationLoading: true,
                locations: [],

                officeLoading: false,
                offices: [],

                sectorLoading: true,
                sectors: [],

                subsectorLoading: false,
                subsectors: [],

                serviceLoading: true,
                services: [],

                subserviceLoading: false,
                subservices: [],

                btnLoading: false,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            this.fetchLocations();
            this.fetchSectors();
            this.fetchServices();
        },
        methods: {


            fetchLocations() {
                this.locationLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/people-locations',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        paginate: 1000,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.locationLoading = false;
                        this.locations = res.data.rows;
                        //
                    })
                    .catch(() => {})
                    .finally(() => {})
            },

            fetchOffices() {
                this.officeLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/people-offices',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        just_location_id: this.row.location_id,
                        paginate: 1000,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.officeLoading = false;
                        this.offices = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {})
            },

            fetchSectors() {
                this.sectorLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/people-sectors',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        paginate: 1000,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.sectorLoading = false;
                        this.sectors = res.data.rows;
                        //
                    })
                    .catch(() => {})
                    .finally(() => {})
            },

            fetchSubSectors() {
                this.subsectorLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/people-sectors',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        just_parent_id: this.row.sector_id,
                        paginate: 1000,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.subsectorLoading = false;
                        this.subsectors = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {})
            },

            fetchServices() {
                this.serviceLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/people-services',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        paginate: 1000,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.serviceLoading = false;
                        this.services = res.data.rows;
                        //
                    })
                    .catch(() => {})
                    .finally(() => {})
            },

            fetchSubServices() {
                this.subserviceLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/people-services',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        just_parent_id: this.row.service_id,
                        paginate: 1000,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.subserviceLoading = false;
                        this.subservices = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {})
            },
            
            // Add New
            addNew(){
                this.btnLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                const options = {
                    url: window.baseURL+'/people',
                    method: 'POST',
                    data: {
                        status: this.row.status,
                        sort: this.row.sort,

                        has_faq: this.row.has_faq,
                        faq_link: this.row.faq_link,

                        has_download: this.row.has_download,
                        download_name: this.row.download_name,
                        download_name_ar: this.row.download_name_ar,
                        download_image: this.row.download_image,
                        download_file: this.row.download_file,

                        background: this.row.background,
                        bgTitle: this.row.bgTitle,
                        bgTitle_ar: this.row.bgTitle_ar,
                        bgMaskColor: this.row.bgMaskColor,

                        image: this.row.image,
                        bgColor: this.row.bgColor,

                        name: this.row.name,
                        name_ar: this.row.name_ar,
                        slug: this.row.slug,
                        position: this.row.position,
                        position_ar: this.row.position_ar,
                        email: this.row.email,
                        phone_d: this.row.phone_d,
                        phone_f: this.row.phone_f,

                        location_id: this.row.location_id,
                        office_id: this.row.office_id,
                        sector_id: this.row.sector_id,
                        subsector_id: this.row.subsector_id,
                        service_id: this.row.service_id,
                        subservice_id: this.row.subservice_id,
                    }
                }
                this.axios(options, config)
                    .then(() => {
                        this.btnLoading = false;
                        iziToast.success({
                            icon: 'ti-check',
                            title: 'Great job,',
                            message: 'Item Added Successfully.',
                        });
                        this.$router.push({ name: 'people' })
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {})
            },


            // Title
            onTitleChange() {
                this.onSlugChange(this.row.name);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str){
                if(!str) {
                   let str = this.row.slug;
                   this.row.slug = str.replace(/\s+/g, '-')
                                      .replace(/\?+/g, '-')
                                      .replace(/\/+/g, '-')
                                      .replace(/\\+/g, '-');
                } else {
                    this.row.slug = str.replace(/\s+/g, '-')
                                      .replace(/\?+/g, '-')
                                      .replace(/\/+/g, '-')
                                      .replace(/\\+/g, '-');
                }
            },


            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image = e.target.result;
                };
            },

            onBackgroundChange(e){
                const file = e.target.files[0];
                this.row.background_preview = URL.createObjectURL(file);
                this.createBase64Background(file);
            },
            createBase64Background(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.background = e.target.result;
                };
            },


            onFileChange(e){
                const file = e.target.files[0];
                this.row.download_preview = URL.createObjectURL(file);
                this.createBase64File(file);
            },
            createBase64File(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.download_file = e.target.result;
                };
            },

            onFilePreviewChange(e){
                const file = e.target.files[0];
                this.row.download_image_preview = URL.createObjectURL(file);
                this.createBase64FilePreview(file);
            },
            createBase64FilePreview(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.download_image = e.target.result;
                };
            },


            
            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },
            onFaq(){
                if(this.row.has_faq)
                    this.row.has_faq = 0;
                else
                    this.row.has_faq = 1;
            },
            onDownload(){
                if(this.row.has_download)
                    this.row.has_download = 0;
                else
                    this.row.has_download = 1;
            },
            

            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: 'people' });
                }
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
